import styled from "styled-components";
import { TABLET } from "@minerva-analytics/pantheon";
import {
  BODY_TEXT_COLOR,
  BORDER_COLOR,
  FOOTER_COLOR,
  HOVER_COLOR,
  SECONDARY_COLOR,
  TITLE_FONT,
} from "../../theme";

const SubscribeContainer = styled.div`
  padding-top: 2rem;
  display: flex;
  flex-direction: column;
  max-width: 80%;
`;

// Add any product specific styling here
const SubscribeFormTheme = {
  Input: `
  margin: 0;
  font-family: ${TITLE_FONT};
  font-size: 18px;
  height: 58px;
  width: 468px;
  border: 1px solid ${BORDER_COLOR};
  border-radius: 6px;
  box-shadow: inset 0 0 6px 0 rgba(204,204,204,0.5);
  box-sizing: border-box;
  background-color: ${FOOTER_COLOR};
  line-height: 33px;

  ::placeholder {
    color: ${BODY_TEXT_COLOR},
    font-family: ${TITLE_FONT};
    font-weight: bold;
    letter-spacing: 0.68px;
    line-height: 38px;
  }

  @media (max-width: ${TABLET}) {
    font-size: 16px;
    min-width: 220px;
  }
  `,
  Button: `
    width: 159px;
    font-size: 20px;
    line-height: 20px;
    letter-spacing: 0.5px;
    height: 58px;
    border-radius: 6px;
    min-width: 104px;
    text-transform: uppercase;
    font-family: ${TITLE_FONT};
    background-color: ${SECONDARY_COLOR};
    :hover {
      background-color: ${HOVER_COLOR};
    } 
    color: ${FOOTER_COLOR};
    font-weight: 600;
  `,
};

export { SubscribeContainer, SubscribeFormTheme };
